import styled from 'styled-components';
import { border, grid, space, layout, position, flexbox, color, compose, typography, } from 'styled-system';
const Box = styled.div `
  box-sizing: border-box;
  ${compose(space, layout, position, flexbox, color, typography, grid, border)};
`;
Box.displayName = 'Box';
export { Box };
//# sourceMappingURL=Box.js.map